import { useContext } from 'react';
import { FaEdit, FaPrint } from 'react-icons/fa';
import dayjs from 'dayjs';

import { ToastContext } from '../../../contexts/toast.context.jsx';

import {
  MainContainer,
  ContentContainer,
  PrinterContainer,
  Subtitle,
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
  Text
} from '../../../styles/component.styles.jsx';

const FulfillmentDisplay = ({ fulfillment = {}, getFulfillment = () => {}, setShowUpdate = () => {} }) => {
  const { successToast } = useContext(ToastContext);

  const handleCopy = (text, successMessage) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    successToast(successMessage);
  };

  if (!fulfillment || !fulfillment.Order) {
    return (
      <MainContainer>
        <Text>Loading fulfillment data...</Text>
      </MainContainer>
    );
  }

  const order = fulfillment.Order;

  return (
    <MainContainer>
      <PrinterContainer>
        <FaEdit onClick={() => setShowUpdate(true)} style={{ fontSize: '24px' }} title="Update" />
      </PrinterContainer>

      <ContentContainer>
        <Subtitle>{`Fulfillment #${fulfillment.id}`}</Subtitle>
        <Subtitle onClick={() => handleCopy(order.refId, 'Copied Order ID')}>
          Order ID: {order.refId}
        </Subtitle>
        <Subtitle>Status: {fulfillment.status}</Subtitle>
        <Subtitle>Created: {dayjs(fulfillment.createdAt).format('MM/DD/YYYY')}</Subtitle>

        {fulfillment.trackingNumber && (
          <Text>Tracking: {fulfillment.trackingNumber}</Text>
        )}

        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Product</TableHead>
              <TableHead>SKU</TableHead>
              <TableHead>Size</TableHead>
              <TableHead>Qty</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {fulfillment.FulfillmentItems?.map((item, i) => {
              const orderItem = fulfillment.Order.OrderItems.filter(oi => oi.id === item.orderItemId)[0];
              const product = orderItem?.Product;
              const inventory = product.Inventories.filter(inv => inv.id === orderItem.inventoryId)[0];

              return (
                <TableRow key={i}>
                  <td>{product?.name || '—'}</td>
                  <td>{inventory?.sku || '—'}</td>
                  <td>{inventory?.size || '—'}</td>
                  <td>{item.quantity}</td>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        <ContentContainer>
          <ContentContainer>
            <Text>Shipping Method</Text>
            <Text>{fulfillment.shippingMethod || 'Standard'}</Text>
          </ContentContainer>
          {fulfillment.notes && (
            <ContentContainer>
              <Text>Notes</Text>
              <Text>{fulfillment.notes}</Text>
            </ContentContainer>
          )}
        </ContentContainer>
      </ContentContainer>

      {fulfillment.issues && (
        <ContentContainer>
          <Subtitle>Issues</Subtitle>
          <Text>{fulfillment.issues}</Text>
        </ContentContainer>
      )}
    </MainContainer>
  );
};

export default FulfillmentDisplay;